import React, { useEffect, useRef, useState } from 'react';
import { Auth } from 'aws-amplify';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import './QuickSightPage.css';
import { ClipLoader } from 'react-spinners'; // Import ClipLoader

const QuickSightPage = () => {
  const dashboardRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true); // State for loading spinner

  useEffect(() => {
    const embed = async () => {
      try {
        const data = await Auth.currentSession();
        const jwtToken = data.idToken.jwtToken;
        const payloadSub = data.idToken.payload.sub;
        const email = data.idToken.payload.email;
        const quicksighturl = process.env.REACT_APP_quicksighturl;

        const queryParams = new URLSearchParams({
          jwtToken,
          payloadSub,
          email,
        });
        const requestUrl = `${quicksighturl}?${queryParams}`;

        const response = await fetch(requestUrl, { method: 'GET' });
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.status}`);
        }

        const quicksightData = await response.json();
        const embeddingUrl = quicksightData.data.EmbedUrl;

        const options = {
          url: embeddingUrl,
          container: dashboardRef.current,
          parameters: {
            country: 'United States',
          },
          scrolling: 'no',
          height: '720px',
          width: '100%',
          footerPaddingEnabled: true,
        };

        embedDashboard(options);
      } catch (error) {
        console.error('Error embedding QuickSight dashboard:', error);
      } finally {
        setIsLoading(false); // Stop spinner when embedding is complete
      }
    };

    embed();
  }, []);

  return (
    <div className="quicksight-iframe-container">
      {isLoading && ( // Show spinner while loading
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
          }}
        >
          <ClipLoader color="#3498db" loading={isLoading} size={50} />
        </div>
      )}
      <div ref={dashboardRef} style={{ display: isLoading ? 'none' : 'block' }}></div> {/* Render dashboard after loading */}
    </div>
  );
};

export default QuickSightPage;
